import { baseApi } from '../baseApi';

export const generalRenewalsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    getGeneralRenewals: builder.query({
      query: (params = {}) => {
        // Dashboard mini-table passes a plain string ('NEXT_7')
        if (typeof params === 'string') {
          return {
            url: '/dashboard/general-renewals',
            method: 'GET',
            params: { filterType: params },
          };
        }

        // Detail page / infinite-scroll passes a full object
        return {
          url: '/dashboard/general-renewals',
          method: 'GET',
          params: {
            ...params,
            pageNumber: params.pageNumber ?? 1,
            pageSize: params.pageSize ?? 30,
          },
        };
      },
    }),

  }),
});

export const {
  useGetGeneralRenewalsQuery,
  useLazyGetGeneralRenewalsQuery,
} = generalRenewalsApi;
